var map = {
	"./about-us-icon": [
		22002,
		2002
	],
	"./about-us-icon.tsx": [
		22002,
		2002
	],
	"./add-icon": [
		4967,
		4967
	],
	"./add-icon.tsx": [
		4967,
		4967
	],
	"./add-profile-icon": [
		94920,
		4920
	],
	"./add-profile-icon.tsx": [
		94920,
		4920
	],
	"./add-to-basket-icon": [
		75902,
		5902
	],
	"./add-to-basket-icon.tsx": [
		75902,
		5902
	],
	"./aod-icon": [
		16120,
		9733
	],
	"./aod-icon.tsx": [
		16120,
		9733
	],
	"./aparat-icon": [
		1670,
		1670
	],
	"./aparat-icon.tsx": [
		1670,
		1670
	],
	"./appointment-icon": [
		95657,
		5657
	],
	"./appointment-icon.tsx": [
		95657,
		5657
	],
	"./arrow": [
		2134,
		2134
	],
	"./arrow-down-icon": [
		42849,
		2849
	],
	"./arrow-down-icon.tsx": [
		42849,
		2849
	],
	"./arrow-left-icon": [
		59402,
		9402
	],
	"./arrow-left-icon.tsx": [
		59402,
		9402
	],
	"./arrow-right-icon": [
		33500,
		3500
	],
	"./arrow-right-icon.tsx": [
		33500,
		3500
	],
	"./arrow-up-icon": [
		94897,
		47
	],
	"./arrow-up-icon.tsx": [
		94897,
		47
	],
	"./arrow.tsx": [
		2134,
		2134
	],
	"./attach-icon": [
		64638,
		4638
	],
	"./attach-icon.tsx": [
		64638,
		4638
	],
	"./back-to-top-icon": [
		57857,
		7857
	],
	"./back-to-top-icon.tsx": [
		57857,
		7857
	],
	"./basket-icon": [
		42133,
		2133
	],
	"./basket-icon.tsx": [
		42133,
		2133
	],
	"./bus-icon": [
		34826,
		4826
	],
	"./bus-icon.tsx": [
		34826,
		4826
	],
	"./calendar-icon": [
		4007,
		4007
	],
	"./calendar-icon.tsx": [
		4007,
		4007
	],
	"./camera-icon": [
		44704,
		4704
	],
	"./camera-icon.tsx": [
		44704,
		4704
	],
	"./cart-icon": [
		24013,
		4013
	],
	"./cart-icon.tsx": [
		24013,
		4013
	],
	"./category-icon": [
		97999,
		7999
	],
	"./category-icon.tsx": [
		97999,
		7999
	],
	"./check-list-icon": [
		74521,
		4521
	],
	"./check-list-icon.tsx": [
		74521,
		4521
	],
	"./close-icon": [
		32202,
		2202
	],
	"./close-icon.tsx": [
		32202,
		2202
	],
	"./comment-icon": [
		14289,
		4289
	],
	"./comment-icon.tsx": [
		14289,
		4289
	],
	"./consult-icon": [
		2836,
		2836
	],
	"./consult-icon.tsx": [
		2836,
		2836
	],
	"./contacts-icon": [
		52916,
		2916
	],
	"./contacts-icon.tsx": [
		52916,
		2916
	],
	"./current-location-icon": [
		80873,
		873
	],
	"./current-location-icon.tsx": [
		80873,
		873
	],
	"./danger-icon": [
		53086,
		3086
	],
	"./danger-icon.tsx": [
		53086,
		3086
	],
	"./delete-icon": [
		64524,
		4524
	],
	"./delete-icon.tsx": [
		64524,
		4524
	],
	"./direct-box-receive-icon": [
		14159,
		2146
	],
	"./direct-box-receive-icon.tsx": [
		14159,
		2146
	],
	"./dislike-icon": [
		74576,
		4576
	],
	"./dislike-icon.tsx": [
		74576,
		4576
	],
	"./document-icon": [
		42306,
		2306
	],
	"./document-icon.tsx": [
		42306,
		2306
	],
	"./download-icon": [
		25142,
		5142
	],
	"./download-icon.tsx": [
		25142,
		5142
	],
	"./edit-icon": [
		5713,
		5713
	],
	"./edit-icon.tsx": [
		5713,
		5713
	],
	"./education-icon": [
		6802,
		6802
	],
	"./education-icon.tsx": [
		6802,
		6802
	],
	"./elevator-icon": [
		40359,
		359
	],
	"./elevator-icon.tsx": [
		40359,
		359
	],
	"./emergency-icon": [
		90906,
		906
	],
	"./emergency-icon.tsx": [
		90906,
		906
	],
	"./envelope": [
		19876,
		9876
	],
	"./envelope.tsx": [
		19876,
		9876
	],
	"./exit-icon": [
		73036,
		3036
	],
	"./exit-icon.tsx": [
		73036,
		3036
	],
	"./experience-icon": [
		42800,
		2800
	],
	"./experience-icon.tsx": [
		42800,
		2800
	],
	"./eye-icon": [
		88584,
		8584
	],
	"./eye-icon.tsx": [
		88584,
		8584
	],
	"./faq-icon": [
		71131,
		1131
	],
	"./faq-icon.tsx": [
		71131,
		1131
	],
	"./filter-icon": [
		11615,
		1615
	],
	"./filter-icon.tsx": [
		11615,
		1615
	],
	"./ham-icon": [
		12001,
		2001
	],
	"./ham-icon.tsx": [
		12001,
		2001
	],
	"./hamburger-icon": [
		29479,
		9479
	],
	"./hamburger-icon.tsx": [
		29479,
		9479
	],
	"./home-care-icon": [
		31097,
		1097
	],
	"./home-care-icon.tsx": [
		31097,
		1097
	],
	"./honor-icon": [
		14277,
		4277
	],
	"./honor-icon.tsx": [
		14277,
		4277
	],
	"./instagram-icon": [
		42097,
		2097
	],
	"./instagram-icon.tsx": [
		42097,
		2097
	],
	"./insurance-icon": [
		73023,
		3023
	],
	"./insurance-icon.tsx": [
		73023,
		3023
	],
	"./judge-icon": [
		17618,
		7618
	],
	"./judge-icon.tsx": [
		17618,
		7618
	],
	"./labs-icon": [
		56204,
		6204
	],
	"./labs-icon.tsx": [
		56204,
		6204
	],
	"./like-icon": [
		33425,
		3425
	],
	"./like-icon.tsx": [
		33425,
		3425
	],
	"./location-icon": [
		82977,
		2977
	],
	"./location-icon.tsx": [
		82977,
		2977
	],
	"./location-outline-icon": [
		18190,
		8190
	],
	"./location-outline-icon.tsx": [
		18190,
		8190
	],
	"./location-tick-icon": [
		28363,
		8363
	],
	"./location-tick-icon.tsx": [
		28363,
		8363
	],
	"./login-icon": [
		57324,
		7324
	],
	"./login-icon.tsx": [
		57324,
		7324
	],
	"./logo-icon": [
		19089,
		9089
	],
	"./logo-icon.tsx": [
		19089,
		9089
	],
	"./logout-icon": [
		86168,
		7216
	],
	"./logout-icon.tsx": [
		86168,
		7216
	],
	"./message-icon": [
		80204,
		204
	],
	"./message-icon.tsx": [
		80204,
		204
	],
	"./metro-icon": [
		47359,
		7359
	],
	"./metro-icon.tsx": [
		47359,
		7359
	],
	"./microphone-icon": [
		25911,
		5911
	],
	"./microphone-icon.tsx": [
		25911,
		5911
	],
	"./microphone-off-icon": [
		73053,
		3053
	],
	"./microphone-off-icon.tsx": [
		73053,
		3053
	],
	"./mobile-appointment-icon": [
		13065,
		3065
	],
	"./mobile-appointment-icon.tsx": [
		13065,
		3065
	],
	"./mobile-consult-icon": [
		41409,
		1409
	],
	"./mobile-consult-icon.tsx": [
		41409,
		1409
	],
	"./mobile-courier-rush-icon": [
		57138,
		7138
	],
	"./mobile-courier-rush-icon.tsx": [
		57138,
		7138
	],
	"./mobile-laboratory-icon": [
		60252,
		252
	],
	"./mobile-laboratory-icon.tsx": [
		60252,
		252
	],
	"./mobile-medical-icon": [
		70699,
		699
	],
	"./mobile-medical-icon.tsx": [
		70699,
		699
	],
	"./mobile-otc-banner-icon": [
		39692,
		9692
	],
	"./mobile-otc-banner-icon.tsx": [
		39692,
		9692
	],
	"./mobile-pharmacy-icon": [
		89130,
		9130
	],
	"./mobile-pharmacy-icon.tsx": [
		89130,
		9130
	],
	"./mobile-pharmacy-otc-icon": [
		49893,
		9893
	],
	"./mobile-pharmacy-otc-icon.tsx": [
		49893,
		9893
	],
	"./mobile-pharmacy-prescription-icon": [
		80392,
		392
	],
	"./mobile-pharmacy-prescription-icon.tsx": [
		80392,
		392
	],
	"./mobile-pharmacy-user-prescription-icon": [
		78338,
		8338
	],
	"./mobile-pharmacy-user-prescription-icon.tsx": [
		78338,
		8338
	],
	"./mobile-select-address-icon": [
		14053,
		4053
	],
	"./mobile-select-address-icon.tsx": [
		14053,
		4053
	],
	"./mobile-shop-icon": [
		3382,
		3382
	],
	"./mobile-shop-icon.tsx": [
		3382,
		3382
	],
	"./more-info-icon": [
		38253,
		8253
	],
	"./more-info-icon.tsx": [
		38253,
		8253
	],
	"./navigation-home-icon": [
		38214,
		8214
	],
	"./navigation-home-icon.tsx": [
		38214,
		8214
	],
	"./navigation-profile-icon": [
		71337,
		1337
	],
	"./navigation-profile-icon.tsx": [
		71337,
		1337
	],
	"./navigation-request-icon": [
		72376,
		2376
	],
	"./navigation-request-icon.tsx": [
		72376,
		2376
	],
	"./navigation-sms-icon": [
		89011,
		9011
	],
	"./navigation-sms-icon.tsx": [
		89011,
		9011
	],
	"./no-information-icon": [
		62724,
		2724
	],
	"./no-information-icon.tsx": [
		62724,
		2724
	],
	"./notice-icon": [
		44645,
		4645
	],
	"./notice-icon.tsx": [
		44645,
		4645
	],
	"./notification-icon": [
		86399,
		6399
	],
	"./notification-icon.tsx": [
		86399,
		6399
	],
	"./ordering-icon": [
		31930,
		1930
	],
	"./ordering-icon.tsx": [
		31930,
		1930
	],
	"./parking-icon": [
		48562,
		8562
	],
	"./parking-icon.tsx": [
		48562,
		8562
	],
	"./pdf-icon": [
		17681,
		7681
	],
	"./pdf-icon.tsx": [
		17681,
		7681
	],
	"./person-icon": [
		37536,
		7536
	],
	"./person-icon.tsx": [
		37536,
		7536
	],
	"./pharmacies-icon": [
		12379,
		2379
	],
	"./pharmacies-icon.tsx": [
		12379,
		2379
	],
	"./phone-white-icon": [
		94168,
		4168
	],
	"./phone-white-icon.tsx": [
		94168,
		4168
	],
	"./play-icon": [
		26922,
		6922
	],
	"./play-icon.tsx": [
		26922,
		6922
	],
	"./posts-icon": [
		54112,
		4112
	],
	"./posts-icon.tsx": [
		54112,
		4112
	],
	"./products-icon": [
		40297,
		297
	],
	"./products-icon.tsx": [
		40297,
		297
	],
	"./profile-circle-icon": [
		12856,
		2856
	],
	"./profile-circle-icon.tsx": [
		12856,
		2856
	],
	"./profile-icon": [
		62183,
		2183
	],
	"./profile-icon.tsx": [
		62183,
		2183
	],
	"./question-icon": [
		78208,
		8208
	],
	"./question-icon.tsx": [
		78208,
		8208
	],
	"./rate-icon": [
		71042,
		1042
	],
	"./rate-icon.tsx": [
		71042,
		1042
	],
	"./rotate-left-icon": [
		41346,
		1346
	],
	"./rotate-left-icon.tsx": [
		41346,
		1346
	],
	"./search-icon": [
		16140,
		6140
	],
	"./search-icon.tsx": [
		16140,
		6140
	],
	"./send-message-icon": [
		10770,
		770
	],
	"./send-message-icon.tsx": [
		10770,
		770
	],
	"./share-icon": [
		43058,
		3058
	],
	"./share-icon.tsx": [
		43058,
		3058
	],
	"./shield-tick-icon": [
		78041,
		8041
	],
	"./shield-tick-icon.tsx": [
		78041,
		8041
	],
	"./sort-icon": [
		74534,
		4534
	],
	"./sort-icon.tsx": [
		74534,
		4534
	],
	"./step-complete-icon": [
		28324,
		8324
	],
	"./step-complete-icon.tsx": [
		28324,
		8324
	],
	"./step-hold-icon": [
		61092,
		1092
	],
	"./step-hold-icon.tsx": [
		61092,
		1092
	],
	"./support-icon": [
		7485,
		7485
	],
	"./support-icon.tsx": [
		7485,
		7485
	],
	"./synchronize-icon": [
		76380,
		6380
	],
	"./synchronize-icon.tsx": [
		76380,
		6380
	],
	"./taxi-icon": [
		14117,
		4117
	],
	"./taxi-icon.tsx": [
		14117,
		4117
	],
	"./telegram-icon": [
		31178,
		1178
	],
	"./telegram-icon.tsx": [
		31178,
		1178
	],
	"./time-icon": [
		68284,
		8284
	],
	"./time-icon.tsx": [
		68284,
		8284
	],
	"./trash-icon": [
		38655,
		8655
	],
	"./trash-icon.tsx": [
		38655,
		8655
	],
	"./upload-cloud-icon": [
		22399,
		2399
	],
	"./upload-cloud-icon.tsx": [
		22399,
		2399
	],
	"./users-icon": [
		7729,
		7729
	],
	"./users-icon.tsx": [
		7729,
		7729
	],
	"./video-icon": [
		45559,
		5559
	],
	"./video-icon.tsx": [
		45559,
		5559
	],
	"./view-icon": [
		95954,
		5954
	],
	"./view-icon.tsx": [
		95954,
		5954
	],
	"./wallet-check-icon": [
		33688,
		3688
	],
	"./wallet-check-icon.tsx": [
		33688,
		3688
	],
	"./wallet-round-icon": [
		25,
		25
	],
	"./wallet-round-icon.tsx": [
		25,
		25
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 900;
module.exports = webpackAsyncContext;